import { render, staticRenderFns } from "./WeeklyOverview.vue?vue&type=template&id=5d9210f5&scoped=true"
import script from "./WeeklyOverview.vue?vue&type=script&lang=js"
export * from "./WeeklyOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9210f5",
  null
  
)

export default component.exports